import React, { useState } from 'react';
import { Gift, X } from 'lucide-react';

const fmt = (iso) => new Date(iso).toLocaleString('fr-FR', { timeZone: 'Europe/Paris', dateStyle: 'short', timeStyle: 'short' });

export const getActiveRideGift = (user) => {
  const promo = user?.pending_promo;
  if (promo?.type !== 'free_first_ride') return null;
  if (promo.expires_at && new Date(promo.expires_at) <= new Date()) return null;
  return promo;
};

export const RideGiftBanner = ({ gift }) => {
  const [hidden, setHidden] = useState(false);
  if (!gift || hidden) return null;
  const notYet = gift.valid_from && new Date(gift.valid_from) > new Date();
  const km = Math.min(Number(gift.max_distance_km || 10), 10);
  return (
    <div className="absolute left-1/2 top-20 z-[2100] w-[min(92vw,34rem)] -translate-x-1/2 rounded-lg border border-[#FFD60A]/50 bg-[#18181B]/95 p-3 shadow-xl backdrop-blur" data-testid="ride-gift-banner">
      <div className="flex items-start gap-3">
        <Gift className="mt-0.5 h-5 w-5 shrink-0 text-[#FFD60A]" />
        <div className="text-sm text-zinc-200">
          <p className="font-bold text-white">1 course offerte jusqu’à {km} km routiers</p>
          <p className="mt-1 text-zinc-300">
            {notYet ? `Activable à partir du ${fmt(gift.valid_from)}. ` : ''}
            {gift.expires_at ? `Valable jusqu’au ${fmt(gift.expires_at)}. ` : ''}
            Choisis une destination à {km} km routiers maximum et demande ta course : elle est offerte automatiquement, sans paiement.
          </p>
        </div>
        <button type="button" onClick={() => setHidden(true)} aria-label="Masquer" data-testid="ride-gift-banner-close"><X className="h-4 w-4 text-zinc-500" /></button>
      </div>
    </div>
  );
};
